import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import { ArticleList } from '@/components/ArticleList';
import { loadPosts } from '@/utils/loadPosts';
import { useAppFonts } from '@/hooks/use-fonts';
import { PostInfo } from '@/components/md-blog';

// @ts-ignore
const mdxctx = require.context('../../../../articles', true, /\.(mdx|js)$/);

const POSTS = loadPosts(mdxctx);

type PageType = {
  truncated?: boolean;
};

const App: React.FC<PageType> = React.memo(({ truncated }) => {
  const { series } = useLocalSearchParams<{ series: string }>();
  const { fontsLoaded } = useAppFonts();

  const filteredPosts = React.useMemo(() => {
    return POSTS.filter((post: PostInfo) => post.series === series);
  }, [series]);

  return (
    <div className="space-y-6 w-full mx-auto">
      <ArticleList
        posts={filteredPosts}
        truncated={truncated}
        isLoading={!fontsLoaded}
      />
    </div>
  );
});

export default App;
